import React from 'react';
import Grid from '@material-ui/core/Grid';
import red from '@material-ui/core/colors/red';
import classNames from 'classnames';
import { compose } from 'ramda';
import { withStyles, } from '@/decorators';
import { connect } from '@/utils';
export const styles = ({ spacing }) => ({
    root: {
        minHeight: spacing(4),
    },
    message: {
        fontSize: '0.75rem',
        lineHeight: '1.5em',
        color: red[500],
        '&$visible': {
            visibility: 'visible',
        },
        '&$hidden': {
            visibility: 'hidden',
        },
    },
    visible: {},
    hidden: {},
});
export const selectors = {
    message: ({ ui: { errors } }) => errors,
};
export const mergeProps = (stateProps, _, props) => ({
    message: stateProps.message[props.forId],
});
export const enhance = compose(withStyles(styles), connect(selectors, null, mergeProps));
const ErrorMessage = enhance(function ErrorMessage({ message, className, classes, }) {
    return (<Grid container item xs={12} justify="center" spacing={2} classes={{ container: classNames(classes.root, className) }}>
      <span className={classNames(message ? classes.visible : classes.hidden, classes.message)}>{message}</span>
    </Grid>);
});
export default ErrorMessage;
